/* =========================================================
   Plantive About Us Page - JS (Simple Fade Reveal)
========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  
  // 👀 Reveal Animation on Scroll (Fade Up นุ่มๆ ไม่หวือหวา)
  const observeElements = document.querySelectorAll('.js-plv-reveal');
  
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.classList.add('is-visible');
        });
        // ให้โชว์แล้วโชว์เลย ไม่ต้องกลับไปซ่อนอีก
        obs.unobserve(entry.target);
      }
    });
  }, { 
    threshold: 0.1, 
    rootMargin: "0px 0px -50px 0px" 
  }); 

  observeElements.forEach(el => observer.observe(el));
  
});